var urlUtils = require('../utils/_urlUtils');

class mFormPostalCode extends HTMLDivElement {
    constructor() {
        super();
        this.form = this.closest('[is="m-ajax-form"]');
        this.inputPart1 = this.querySelector('[data-ref="postalCodePart1"]');
        this.inputPart2 = this.querySelector('[data-ref="postalCodePart2"]');
        this.inputFull = this.form.querySelector('[data-ref="postalCodeFull"]');
        this.jpPostalCode = this.querySelector('#jp-postal-code');
        this.btnAutocomplete = this.querySelector('[data-ref="btnAutocomplete"]');
        this.url = this.dataset.autocompleteUrl;
        this.hidden = null;

        this.computePostalCode = this.computePostalCode.bind(this);
        this.autocompleteFields = this.autocompleteFields.bind(this);
        this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
        // setup parts value if full postal code is already set
        const parts = this.inputFull.value ? this.inputFull.value.split('-') : [];
        if (parts[0]) {
            this.inputPart1.value = parts[0];
        }
        if (parts[1]) {
            this.inputPart2.value = parts[1];
        }
        this.inputPart1.addEventListener('input', this.onInput);
        this.inputPart2.addEventListener('input', this.onInput);
        this.inputPart1.addEventListener('change', this.computePostalCode);
        this.inputPart2.addEventListener('change', this.computePostalCode);
        this.btnAutocomplete.addEventListener('click', this.autocompleteFields);
        this.computePostalCode();
    }

    validateInputFields() {
        this.form.dispatchEvent(new CustomEvent('form:validateField', {
            detail: {
                field: this.inputPart1
            }
        }));
        this.form.dispatchEvent(new CustomEvent('form:validateField', {
            detail: {
                field: this.inputPart2
            }
        }));
    }

    autocompleteFields() {
        this.validateInputFields();
        if (!this.inputFull || this.inputFull.value.length < 8) {
            return;
        }
        var url = urlUtils.appendToUrl(this.url, {
            zipcode: this.inputFull.value.replace('-', '')
        });
        fetch(url, {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((responseData) => {
            if (responseData.success) {
                for (var field of Object.keys(responseData.fields)) {
                    var value = responseData.fields[field];
                    var inputField = this.form.querySelector('[name$="' + field + '"]');
                    inputField.value = value;
                    inputField.dispatchEvent(new Event('change')); // trigger field validation
                    inputField.dispatchEvent(new Event('input')); // trigger floating label
                    var formField = inputField.closest('.form-field');
                    formField.classList.toggle('is-active', true);
                }
            }
        });
    }

    toggleDisplay(display) {
        this.hidden = !display;
        this.jpPostalCode.classList.toggle('d-none', !display);
        this.inputPart1.required = display;
        this.inputPart1.ariaRequired = display.toString();
        this.inputPart2.required = display;
        this.inputPart2.ariaRequired = display.toString();
        var postalCodeField = this.inputFull.closest('.form-field');
        postalCodeField.classList.toggle('d-none', display);
        postalCodeField.required = !display;
        postalCodeField.ariaRequired = !display.toString();
    }

    onInput(e) {
        if ((e.keyCode >= 37 && e.keyCode <= 40) || e.keyCode === 13) { // Touche Entrée et Fleches directionnels
            return;
        }
        var input = e.target;
        input.value = input.value.replace(/[^\d]+/g, '');
        if (input === this.inputPart1 && this.inputPart1.value.length === 3) {
            this.inputPart2.focus();
        }
    }

    computePostalCode() {
        if (this.hidden) {
            return;
        }
        if (this.inputPart1.value.length === 3 && this.inputPart2.value.length === 4) {
            this.inputFull.value = `${this.inputPart1.value}-${this.inputPart2.value}`;
        }
    }
}

customElements.define('m-form-postal-code', mFormPostalCode, {
    extends: 'div'
});
